module.exports = __webpack_public_path__ + "media/images/center-icon-90ba3ca4d51c73e454955051df8bfe92.png";